var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ChartParams } from "../../views/chart/chart.component";
import { TranslateService } from '../../translate';
import { EventsService } from "../../lib/EventsService";
import { ActivatedRoute } from "@angular/router";
import { FilterFormService } from "../../views/filter_form/filter_form.service";
import { HelperService } from "../../lib/helper.service";
import { ModalService } from "../../views/modal/base_modal.component";
import { BaseComponent } from "../../views/base.component";
import * as moment from 'moment-timezone';
import { BillingService2 } from "../billing.service";
var WithdrawalsRecurrentComponent = /** @class */ (function (_super) {
    __extends(WithdrawalsRecurrentComponent, _super);
    function WithdrawalsRecurrentComponent(translate, eventsService, activatedRoute, filter, modalService, helper, service2) {
        var _this = _super.call(this, eventsService, service2, activatedRoute, filter, translate) || this;
        _this.translate = translate;
        _this.eventsService = eventsService;
        _this.activatedRoute = activatedRoute;
        _this.filter = filter;
        _this.modalService = modalService;
        _this.helper = helper;
        _this.service2 = service2;
        _this.withdrawalsRecurrentByGateChart = new ChartParams();
        _this.withdrawalsRecurrentByTryChart = new ChartParams();
        _this.addFilterParams = {
            userType: 'user',
            isBilling: true,
            dateFilters: ['dateTime', 'dateCreated', 'datePaid', 'dateSiteCreated', 'datePublished'],
            dateType: 'dateTime'
        };
        _this.dataByGate = {
            headers: [],
            rows: []
        };
        _this.dataByTry = {
            headers: [],
            rows: []
        };
        _this.statsByGateLoader = false;
        _this.statsByTryLoader = false;
        _this.withdrawalsRecurrentPercentLoader = 100;
        _this.i18n = {};
        var me = _this;
        me.i18n['month'] = me.translate.__A('filterForm.tariffVariants.month');
        me.i18n['wait'] = me.translate.__A('billing.expired_paid.expected recurents');
        me.i18n['rebill'] = me.translate.__A('billing.expired_paid.recurents');
        me.withdrawalsRecurrentByGateChart.setOptions({
            title: 'По гейтам',
            axis: {
                y: {
                    tick: {
                        format: function (d) {
                            return d + '%';
                        }
                    }
                }
            }
        });
        me.withdrawalsRecurrentByTryChart.setOptions({
            title: 'По попыткам',
            axis: {
                y: {
                    max: 100,
                    tick: {
                        format: function (d) {
                            return d + '%';
                        }
                    }
                }
            }
        });
        return _this;
    }
    WithdrawalsRecurrentComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tickM, endM, i, tick, groupDate, _a, dataByGate, dataByTry;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.withdrawalsRecurrentPercentLoader = 0;
                        tickM = moment().startOf('month');
                        endM = moment('2018-12-01');
                        i = 0;
                        tick = 100 / tickM.diff(endM, 'months');
                        _b.label = 1;
                    case 1:
                        if (!tickM.isAfter(endM)) return [3 /*break*/, 3];
                        groupDate = tickM.format('YYYY-MM-DD');
                        return [4 /*yield*/, this.service2.withdrawalsRecurrent.stats(__assign({}, this.filter.filterParams, { groupDate: groupDate })).toPromise()];
                    case 2:
                        _a = _b.sent(), dataByGate = _a.dataByGate, dataByTry = _a.dataByTry;
                        if (this.dataByGate.headers.length === 0) {
                            this.dataByGate.headers = dataByGate.headers;
                        }
                        if (this.dataByTry.headers.length === 0) {
                            this.dataByTry.headers = dataByTry.headers;
                        }
                        this.dataByGate.rows.push(dataByGate.rows[0]);
                        this.dataByTry.rows.push(dataByTry.rows[0]);
                        tickM.add(-1, 'month');
                        i++;
                        this.withdrawalsRecurrentPercentLoader = Math.ceil(i * tick);
                        return [3 /*break*/, 1];
                    case 3:
                        this.withdrawalsRecurrentPercentLoader = 100;
                        this.withdrawalsRecurrentByGateChart.data = this.extractChartData(this.dataByGate, 'ByGate');
                        this.withdrawalsRecurrentByTryChart.data = this.extractChartData(this.dataByTry, 'ByTry');
                        return [2 /*return*/];
                }
            });
        });
    };
    WithdrawalsRecurrentComponent.prototype.extractChartData = function (data, chartId) {
        var chartData = [];
        var x = data.rows.reduce(function (p, c) { p.push(c[0]); return p; }, ['x']);
        for (var i = 2; i < data.headers.length; i++) {
            var y = [];
            y.push(data.headers[i].title);
            for (var _i = 0, _a = data.rows; _i < _a.length; _i++) {
                var row = _a[_i];
                x.push(row[0]);
                if (chartId === 'ByTry') {
                    if (i === 2) {
                        y.push((parseInt(row[3], 10) || 0));
                    }
                    else {
                        y.push((parseInt(row[(i * 2) - 1], 10) || 0));
                    }
                }
                else {
                    y.push((parseInt(row[(i * 3) - 3], 10) || 0));
                }
            }
            chartData.push(y);
        }
        chartData.unshift(x);
        return chartData;
    };
    return WithdrawalsRecurrentComponent;
}(BaseComponent));
export { WithdrawalsRecurrentComponent };
